import { Outcome } from "@financial-advisory/data-access/api-types";
import { cn } from "@unlikelyai-magic/utils";

export const OutcomePill = ({ value }: { value: Outcome }) => {
  const backgroundColor =
    value === Outcome.TRUE
      ? "bg-green-600"
      : value === Outcome.FALSE
        ? "bg-red-600"
        : "bg-blue-700";
  return (
    <div
      className={cn(
        "flex justify-center w-fit px-2 py-1 rounded-lg",
        backgroundColor
      )}
    >
      <span className="font-semibold text-sm text-white whitespace-nowrap">
        {value}
      </span>
    </div>
  );
};
